<template>
  <div class="cr-actions-menu-wrap" :class="{ 'cr-actions-menu-wrap--button': variant === 'button' }">
    <v-menu
      location="bottom end"
      offset="8"
      :close-on-content-click="true"
    >
    <template #activator="{ props: menuProps }">
      <button
        v-if="variant === 'button'"
        type="button"
        class="cr-actions-trigger cr-actions-trigger--button"
        aria-label="Caller actions"
        v-bind="menuProps"
        @click.stop
      >
        Actions
        <v-icon icon="mdi-chevron-down" size="16" />
      </button>
      <button
        v-else
        type="button"
        class="cr-actions-trigger"
        aria-label="Caller actions"
        v-bind="menuProps"
        @click.stop
      >
        <v-icon icon="mdi-dots-vertical" size="18" />
      </button>
    </template>

    <div class="cr-actions-menu" role="menu">
      <button
        type="button"
        class="cr-actions-menu__item"
        role="menuitem"
        @click="$emit('view', caller)"
      >
        <span class="cr-actions-menu__icon cr-actions-menu__icon--view">
          <v-icon icon="mdi-eye-outline" size="18" />
        </span>
        <span class="cr-actions-menu__text">
          <span class="cr-actions-menu__title">View</span>
          <span class="cr-actions-menu__desc">Open caller profile</span>
        </span>
      </button>

      <button
        type="button"
        class="cr-actions-menu__item"
        role="menuitem"
        @click="$emit('edit', caller)"
      >
        <span class="cr-actions-menu__icon cr-actions-menu__icon--edit">
          <v-icon icon="mdi-account-edit-outline" size="18" />
        </span>
        <span class="cr-actions-menu__text">
          <span class="cr-actions-menu__title">Edit</span>
          <span class="cr-actions-menu__desc">Update caller profile</span>
        </span>
      </button>

      <button
        type="button"
        class="cr-actions-menu__item cr-actions-menu__item--danger"
        role="menuitem"
        @click="$emit('delete', caller)"
      >
        <span class="cr-actions-menu__icon cr-actions-menu__icon--delete">
          <v-icon icon="mdi-trash-can-outline" size="18" />
        </span>
        <span class="cr-actions-menu__text">
          <span class="cr-actions-menu__title">Delete</span>
          <span class="cr-actions-menu__desc">Remove caller profile</span>
        </span>
      </button>
    </div>
  </v-menu>
  </div>
</template>

<script setup>
defineOptions({ name: 'CallersActionMenu' })

defineProps({
  caller: { type: Object, required: true },
  variant: {
    type: String,
    default: 'icon',
    validator: (value) => ['icon', 'button'].includes(value),
  },
})

defineEmits(['view', 'edit', 'delete'])
</script>
